import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer-smacere-tos',
  templateUrl: './footer-smacere-tos.component.html',
  styleUrls: ['./footer-smacere-tos.component.scss'],
})
export class FooterSmacereTOSComponent implements OnInit {
  displayForCeremony = environment.tenant === 'ceremony';
  displayForJoin = environment.tenant === 'join';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}
}
